var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-container"},[_c('div',{staticClass:"bg"}),_c('el-row',{staticClass:"row"},[_c('el-col',{staticClass:"h1"},[_vm._v(" WELCOME "+_vm._s(_vm.username)+" TO")]),_c('el-col',{staticClass:"txt"},[_vm._v("汉英双拼大会 · ERP管理系统")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }